"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CometAiming = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const ResourceType_1 = require("../../ResourceType");
const Tags_1 = require("../Tags");
const SelectCard_1 = require("../../inputs/SelectCard");
const SelectOption_1 = require("../../inputs/SelectOption");
const OrOptions_1 = require("../../inputs/OrOptions");
const constants_1 = require("../../constants");
const LogHelper_1 = require("../../LogHelper");
const PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../turmoil/parties/PartyName");
const PlaceOceanTile_1 = require("../../deferredActions/PlaceOceanTile");
const CardRenderer_1 = require("../render/CardRenderer");
const RedsPolicy_1 = require("../../turmoil/RedsPolicy");
const Units_1 = require("../../Units");
class CometAiming extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.COMET_AIMING,
            tags: [Tags_1.Tags.SPACE],
            cost: 17,
            resourceType: ResourceType_1.ResourceType.ASTEROID,
            metadata: {
                cardNumber: 'X16',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action('Spend 1 titanium to add 1 asteroid resource to ANY CARD.', (eb) => {
                        eb.titanium(1).startAction.asteroids(1).asterix();
                    }).br;
                    b.or().br;
                    b.action('Remove 1 asteroid here to place an ocean.', (eb) => {
                        eb.asteroids(1).startAction.oceans(1);
                    });
                }),
            },
        });
        this.resourceCount = 0;
    }
    play() {
        return undefined;
    }
    canAct(player) {
        const hasTitanium = player.titanium > 0;
        const oceansMaxed = player.game.noOceansAvailable();
        const canPlaceOcean = this.resourceCount > 0 && !oceansMaxed;
        const trGain = oceansMaxed ? 0 : 1;
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
        if (hasTitanium)
            Card_1.Card.setRedsActionWarningText(player, trGain, this, redsAreRuling, 'place an ocean');
        if (oceansMaxed) {
            Card_1.Card.setUselessActionWarningText(this, 'all oceans have already been placed');
        }
        if (redsAreRuling) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: trGain * constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails();
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return hasTitanium || (this.howToAffordReds.canAfford && canPlaceOcean);
        }
        return hasTitanium || canPlaceOcean;
    }
    action(player) {
        const asteroidCards = player.getResourceCards(ResourceType_1.ResourceType.ASTEROID);
        const addAsteroidToSelf = function () {
            player.titanium--;
            player.addResourceTo(asteroidCards[0], { log: true });
            return undefined;
        };
        const addAsteroidToCard = new SelectCard_1.SelectCard('Select card to add 1 asteroid', 'Add asteroid', asteroidCards, (foundCards) => {
            player.titanium--;
            player.addResourceTo(foundCards[0], { log: true });
            return undefined;
        });
        const spendAsteroidResource = () => {
            this.resourceCount--;
            LogHelper_1.LogHelper.logRemoveResource(player, this, 1, 'place an ocean');
            player.game.defer(new PlaceOceanTile_1.PlaceOceanTile(player));
            return undefined;
        };
        if (this.resourceCount === 0) {
            if (asteroidCards.length === 1)
                return addAsteroidToSelf();
            return addAsteroidToCard;
        }
        if (player.titanium === 0 && player.canAfford(this.reserveUnits.megacredits))
            return spendAsteroidResource();
        const availableActions = [];
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
        if (!redsAreRuling || (redsAreRuling && player.canAfford(this.reserveUnits.megacredits))) {
            availableActions.push(new SelectOption_1.SelectOption('Remove an asteroid resource to place an ocean', 'Remove asteroid', spendAsteroidResource));
        }
        if (asteroidCards.length === 1) {
            availableActions.push(new SelectOption_1.SelectOption('Spend 1 titanium to gain 1 asteroid resource', 'Spend titanium', addAsteroidToSelf));
        }
        else {
            availableActions.push(addAsteroidToCard);
        }
        if (availableActions.length === 1) {
            const action = availableActions[0];
            if (action instanceof SelectOption_1.SelectOption)
                return availableActions[0].cb();
            return availableActions[0];
        }
        return new OrOptions_1.OrOptions(...availableActions);
    }
    getActionDetails() {
        return new RedsPolicy_1.ActionDetails({ oceansToPlace: 1 });
    }
}
exports.CometAiming = CometAiming;
//# sourceMappingURL=CometAiming.js.map